import React, { useEffect, useState } from 'react';
import { Badge, Card, Col, ProgressBar, Row, Spinner } from 'react-bootstrap';
import visionTestCardImg from '../../Assets/Img/visionTestCardImg.png';
import { useTranslation } from 'react-i18next';
import { useOrdersCountMutation } from '../Orders/ordersApi';
import { useNavigate } from 'react-router';

const OrdersCount = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const config = {
        patientEmail: '',
        status: 'All,ToBeOrdered,Pending,Commandé,Annulé,SAV,Devis',
        search: '',
        pageNumber: 1,
        pageSize: 10000,
    };
    const [loading, setLoading] = useState(true);
    const [ordersCount] = useOrdersCountMutation();
    const [count, setCount] = useState([]);

    useEffect(() => {
        if (loading) {
            ordersCount(config).then(({ data }) => {
                console.log(data, 'dsadasd dsad ');
                setCount(data);
                setLoading(false);
            });
        }
    }, [loading]);

    const getPercentage = (value) => {
        return (
            (value /
                (count[1] +
                    count[2] +
                    count[3] +
                    count[4] +
                    count[5] +
                    count[6])) *
            100
        );
    };
    return (
        <Card className="mt-4">
            <Card.Header
                className="bg-white d-flex align-items-center"
                style={{ height: '50px' }}
            >
                <div className="d-flex align-items-center gap-2">
                    <div className="cardImgContainer d-flex align-items-center justify-content-center">
                        <img
                            src={visionTestCardImg}
                            style={{ height: '20px' }}
                        />
                    </div>
                    <Card.Title className="mb-0">{t('commandes')}</Card.Title>
                </div>
            </Card.Header>
            <Card.Body>
                {loading ? (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : (
                    <>
                        <div
                            className="order_total"
                            onClick={() => navigate('/order/list')}
                        >
                            <h2>{count[0]}</h2>
                            <h5>Total</h5>
                        </div>
                        <div>
                            <ProgressBar style={{ height: '32px' }}>
                                <ProgressBar
                                    now={getPercentage(count[2])}
                                    style={{ backgroundColor: '#3C93F7' }}
                                />
                                <ProgressBar
                                    now={getPercentage(count[5])}
                                    style={{ backgroundColor: '#EB2F96' }}
                                />
                                <ProgressBar
                                    now={getPercentage(count[6])}
                                    style={{ backgroundColor: '#98D4FF' }}
                                />
                                <ProgressBar
                                    now={getPercentage(count[1])}
                                    style={{ backgroundColor: '#FDC82C' }}
                                />
                                <ProgressBar
                                    now={getPercentage(count[3])}
                                    style={{ backgroundColor: '#039859' }}
                                />
                                <ProgressBar
                                    now={getPercentage(count[4])}
                                    style={{ backgroundColor: '#475467' }}
                                />
                            </ProgressBar>
                            <Row className="mt-5">
                                <Col>
                                    <div
                                        className="count_item"
                                        onClick={() =>
                                            navigate('/order/list?En attente', {
                                                state: { status: 'Pending' },
                                            })
                                        }
                                    >
                                        <h3>{count[2]}</h3>
                                        <div className="">
                                            <Badge
                                                bg="custom"
                                                style={{
                                                    backgroundColor: '#3C93F7',
                                                }}
                                            ></Badge>
                                            <span className="text-secondary">
                                                En attente
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div
                                        className="count_item"
                                        onClick={() =>
                                            navigate('/order/list?SAV', {
                                                state: { status: 'SAV' },
                                            })
                                        }
                                    >
                                        <h3>{count[5]}</h3>
                                        <div className="">
                                            <Badge
                                                bg="custom"
                                                style={{
                                                    backgroundColor: '#EB2F96',
                                                }}
                                            ></Badge>
                                            <span className="text-secondary">
                                                SAV
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div
                                        className="count_item"
                                        onClick={() =>
                                            navigate('/order/list?Devis', {
                                                state: { status: 'Devis' },
                                            })
                                        }
                                    >
                                        <h3>{count[6]}</h3>
                                        <div className="">
                                            <Badge
                                                bg="custom"
                                                style={{
                                                    backgroundColor: '#98D4FF',
                                                }}
                                            ></Badge>
                                            <span className="text-secondary">
                                                Devis
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div
                                        className="count_item"
                                        onClick={() =>
                                            navigate(
                                                '/order/list?À commander',
                                                {
                                                    state: {
                                                        status: 'ToBeOrdered',
                                                    },
                                                }
                                            )
                                        }
                                    >
                                        <h3>{count[1]}</h3>
                                        <div className="">
                                            <Badge
                                                bg="custom"
                                                style={{
                                                    backgroundColor: '#FDC82C',
                                                }}
                                            ></Badge>
                                            <span className="text-secondary">
                                                À commander
                                            </span>
                                        </div>
                                    </div>
                                </Col>

                                <Col>
                                    <div
                                        className="count_item"
                                        onClick={() =>
                                            navigate('/order/list?Commandées', {
                                                state: { status: 'Commandé' },
                                            })
                                        }
                                    >
                                        <h3>{count[3]}</h3>
                                        <div className="">
                                            <Badge
                                                bg="custom"
                                                style={{
                                                    backgroundColor: '#039859',
                                                }}
                                            ></Badge>
                                            <span className="text-secondary">
                                                Commandée
                                            </span>
                                        </div>
                                    </div>
                                </Col>

                                <Col>
                                    <div
                                        className="count_item"
                                        onClick={() =>
                                            navigate('/order/list?Annulées', {
                                                state: { status: 'Annulé' },
                                            })
                                        }
                                    >
                                        <h3>{count[4]}</h3>
                                        <div className="">
                                            <Badge
                                                bg="custom"
                                                style={{
                                                    backgroundColor: '#475467',
                                                }}
                                            ></Badge>
                                            <span className="text-secondary">
                                                Annulée
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </>
                )}
            </Card.Body>
        </Card>
    );
};
export default OrdersCount;
